import { z } from "zod";
import { isValidIanaTimeZone, DEFAULT_TIMEZONE } from "../dates.js";
import { ISODateSchema, ULIDSchema } from "./primitives.js";
import { UserIdSchema } from "./user.js";
export const HouseholdSchema = z
    .object({
    householdId: ULIDSchema("hh"),
    schemaVersion: z.literal(1),
    name: z.string().min(1).max(80),
    timezone: z.string().min(1).max(64).default(DEFAULT_TIMEZONE),
    // createdBy = raw Cognito sub (the founding user). See "Resolved scope decisions" #9.
    createdBy: UserIdSchema,
    createdAt: ISODateSchema,
    updatedAt: ISODateSchema,
    deletedAt: ISODateSchema.nullable(),
})
    .passthrough();
const householdNameSchema = z
    .string()
    .min(1, "name is required")
    .max(80, "name must be ≤ 80 chars")
    .refine((s) => s.trim().length > 0, { message: "name must not be whitespace-only" });
export const CreateHouseholdRequestSchema = z
    .object({ name: householdNameSchema })
    .strict();
export const PatchHouseholdRequestSchema = z
    .object({
    name: householdNameSchema.optional(),
    timezone: z.string().min(1).max(64).refine(isValidIanaTimeZone, "timezone must be a valid IANA zone id").optional(),
})
    .strict()
    .refine((v) => v.name !== undefined || v.timezone !== undefined, "name or timezone required");
export const CreateHouseholdResponseSchema = z.object({
    household: HouseholdSchema,
});
//# sourceMappingURL=household.js.map